import * as React from 'react';

class NotFound extends React.Component<{}> {
    public render() {
        return <div>Page Not Found</div>;
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/common/NotFoundPage.tsx